import {
  Observable,
  BehaviorSubject,
  fromEvent,
  merge,
  combineLatest,
  animationFrameScheduler,
} from 'rxjs';
import {
  map,
  scan,
  startWith,
  shareReplay,
  switchMap,
  distinctUntilChanged,
  auditTime,
  pairwise,
  withLatestFrom,
  finalize,
} from 'rxjs/operators';
import MediaNodeStore from './MediaNodeStore';
import MediaStore from './MediaStore';
import QueryStore from './QueryStore';

const Store = () => {
  const mediaNodeStore = MediaNodeStore();
  const queryStore = QueryStore();
  const mediaStore = MediaStore(mediaNodeStore.$);
  const $ = combineLatest(
    queryStore.$,
    mediaStore.$,
  ).pipe(
    map(([queryState, mediaState]) => ({
      media: mediaState,
      query: queryState,
    })),
    shareReplay(1),
  );

  return {
    $,
    destroy: () => {
      queryStore.destroy();
      mediaNodeStore.destroy();
      mediaStore.destroy();
      if (_.isFunction(_.get($, 'complete'))) $.complete();
    },
    actions: {
      ...queryStore.actions,
      ...mediaNodeStore.actions,
      ...mediaStore.actions,
    },
  };
};

export default Store;
